import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {InputTextModule} from 'primeng/inputtext';
import {NgForOf} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'dmp-table-schema-edit-label-inline',
    templateUrl: './table-schema-edit-label-inline.component.html',
    imports: [
        InputTextModule,
        NgForOf,
        FormsModule,
        TranslateModule
    ],
    styleUrls: ['./table-schema-edit-label-inline.component.scss']
})
export class TableSchemaEditLabelInlineComponent implements OnInit {
    @Input() labels: { [key: string]: string };
    @Output() labelsChange = new EventEmitter();

    i18n: SelectItem[] = [];

    constructor() {
        ['FR', 'EN', 'IT'].forEach(code => this.i18n.push({label: code, value: ''}));
    }

    ngOnInit(): void {
        if (this.labels) {
            ['FR', 'EN', 'IT'].forEach(code => {
                if (this.labels[code]) {
                    this.i18n.find(i => i.label === code).value = this.labels[code];
                }
            });
        }

    }

    change() {
        const labels: { [key: string]: string } = {};
        this.i18n.forEach(i => labels[i.label] = i.value);
        this.labelsChange.emit(labels);
    }
}
